export default "__VITE_ASSET__BldFZb7e__"